module.exports = __webpack_public_path__ + "img/icon_map_3_c.82d37e8c.png";